import React, { useContext, useRef } from 'react';
import StateContext from 'common/contexts/state-context';
import { ROOT_IMG_URL } from '../../GlobalValues';
import SearchField from '../SearchField';
import useFocusTrap from '../../hooks/useFocusTrap';
import useScrollLock from '../../hooks/useScrollLock';
import { BRAND_COPY } from '../../staticContent';

/**
 * Modale « Trouver un salon », identique sur les deux pages.
 *
 * Correction SEO autorisée par la décision 5 : la maquette émettait cette
 * modale tout en haut du body, si bien que son `<h3>` précédait le `<h1>` de la
 * page dans l'ordre du document. Elle est désormais rendue en fin de body (voir
 * App.js) et son titre est un `<p>` stylé comme l'était le `h3` — le visuel ne
 * bouge pas, la hiérarchie des titres redevient correcte.
 */
const SearchModal = ({ isOpen, onClose, onSearch, onSelectPrediction, onGeolocate, isBusy }) => {
  const [state] = useContext(StateContext);
  const boxRef = useRef(null);

  useFocusTrap(isOpen, boxRef, onClose);
  useScrollLock(isOpen);

  return (
    <div
      className={['search-overlay', isOpen ? 'is-open' : null].filter(Boolean).join(' ')}
      role="dialog"
      aria-modal="true"
      aria-label="Trouver un salon"
      aria-hidden={isOpen ? undefined : 'true'}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="search-box" ref={boxRef}>
        <button type="button" className="search-box-close" onClick={onClose} aria-label="Fermer">
          ✕
        </button>
        <div className="search-box-logo">
          <img src={`${ROOT_IMG_URL}LOGO_TCHIP_26.svg`} alt="Tchip Coiffure" width="100" height="50" />
          <p className="search-box-title">Trouver un salon</p>
          <p>{BRAND_COPY.searchModalSubtitle(state.brand?.placeCount)}</p>
        </div>
        <SearchField
          variant="modal"
          submitLabel="Chercher"
          onSearch={onSearch}
          onSelectPrediction={onSelectPrediction}
          onGeolocate={onGeolocate}
          isBusy={isBusy}
          autoFocus={isOpen}
        />
        <p className="search-geo-link">
          Ou{' '}
          <strong
            onClick={onGeolocate}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onGeolocate();
              }
            }}
          >
            activer la géolocalisation
          </strong>
        </p>
      </div>
    </div>
  );
};

export default SearchModal;
